/**
 * OnboardingPage — routes to step 1 when accessed at /onboarding.
 * Each step lives at /onboarding/1, /onboarding/2, /onboarding/3.
 */
import { Navigate } from 'react-router-dom';

export default function OnboardingPage() {
  return <Navigate to="/onboarding/1" replace />;
}
